import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "QuestionName",
    isNumber: true,
    isSum: true,
  },
];

export const CheckAreaToEyeDisease = {
  label: "篩檢場域 VS 眼疾",
  key: "CheckAreaToEyeDisease",
  path: "FundusAbnormal/CheckAreaToEyeDisease",
  api: "TCS_V_EyesS01",
  render: (options) => (
    <Diagram.FundusAbnormal.CheckAreaToEyeDisease {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "Q2649",
      field: "Q2649",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
